import {$http, clearTokenRefreshTimeout, scheduleTokenRefresh} from '@/utils/https';
// import {globalLoader, fixBody} from '@/helpers/variables/index';
import {
  SET_TOKEN,
  REMOVE_TOKEN,
  CHANGE_LOADING,
  SET_LOGIN_DATA,
  CHANGE_EMAIL_CODE_LOADING,
  CHANGE_EMAIL_LOGIN_LOADING
} from '../mutation-types';
import {
  GET_TOKEN,
  LOGOUT,
  LOGIN,
  RESET_PASSWORD,
  RESTORE_PASSWORD,
  GET_EMAIL_CODE,
  SEND_EMAIL_CODE,
} from '../action-types';

const state = {
  loginData: null,
  isAuthenticated: false,
  isLoading: false,
  isLoadingEmailCode: false,
  isLoadingEmailLogin: false,
};

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  isLoading: state => state.isLoading,
  loginData: state => state.loginData,
  isLoadingEmailCode: state => state.isLoadingEmailCode,
  isLoadingEmailLogin: state => state.isLoadingEmailLogin,
};

const actions = {
  [GET_TOKEN]: async ({commit}, payload) => {
    commit(CHANGE_LOADING, true);
    try {
      const result = await $http.post('v1/auth/login', payload);
      commit(SET_LOGIN_DATA, result.data);
    } finally {
      commit(CHANGE_LOADING, false)
    }
  },
  [RESET_PASSWORD]: async ({commit}, payload) => {
    commit(CHANGE_LOADING, true);
    try {
      return await $http.post('v1/auth/password/reset', payload);
    } finally {
      commit(CHANGE_LOADING, false)
    }
  },
  [GET_EMAIL_CODE]: async ({commit}, payload) => {
    commit(CHANGE_EMAIL_CODE_LOADING, true);
    try {
      return await $http.post('v1/auth/send-email-code', payload);
    } finally {
      commit(CHANGE_EMAIL_CODE_LOADING, false)
    }
  },
  [SEND_EMAIL_CODE]: async ({commit}, payload) => {
    commit(CHANGE_EMAIL_LOGIN_LOADING, true);
    try {
      const result = await $http.post('v1/auth/login-email-code', payload);
      commit(SET_TOKEN, result.data.accessToken);
    } finally {
      commit(CHANGE_EMAIL_LOGIN_LOADING, false)
    }
  },
  [RESTORE_PASSWORD]: async ({commit}, payload) => {
    commit(CHANGE_LOADING, true);
    try {
      return await $http.post('v1/auth/password/restore', payload);
    } finally {
      commit(CHANGE_LOADING, false)
    }
  },
  [LOGIN]: async ({commit}, payload) => {
    commit(CHANGE_LOADING, true);
    try {
      const result = await $http.post('v1/auth/login2fa', payload);
      commit(SET_TOKEN, result.data.accessToken);
    } finally {
      commit(CHANGE_LOADING, false)
    }
  },
  [LOGOUT]: async ({commit}) => {
    try {

      return await $http.post('v1/logout');
    } finally {
      commit(REMOVE_TOKEN);
    }
  },
};

const mutations = {
  [SET_LOGIN_DATA](state, data){
    state.loginData = data
  },
  [SET_TOKEN](state, token) {
    state.isAuthenticated = true;
    localStorage.setItem('user_token', token);
    scheduleTokenRefresh(token);
  },
  [REMOVE_TOKEN](state) {
    clearTokenRefreshTimeout();
    localStorage.removeItem('user_token');
    state.isAuthenticated = false;
    setTimeout(() => {
      location.reload()
    }, 200)

  },
  [CHANGE_LOADING](state, status) {
    state.isLoading = status;
  },
  [CHANGE_EMAIL_CODE_LOADING](state, status) {
    state.isLoadingEmailCode = status;
  },
  [CHANGE_EMAIL_LOGIN_LOADING](state, status) {
    state.isLoadingEmailLogin = status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
